














































import {Component, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/HeaderBar.vue'
import MenusStore from "@/store/modules/MenusStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import SchedulesStore from "@/store/modules/SchedulesStore";
import ScheduleEditor from "@/pages/SchedulePages/ScheduleEditor.vue";
import DeleteScheduleDialog from "@/components/Dialog/DeleteScheduleDialog.vue";
import {CmsApiUtil} from "@/_common/api/utils/cms_api_utils";
import {Util} from "@/_global/utils";
import dateToUI = CmsApiUtil.dateToUI;
import Navigator from '@/components/Navigator.vue';

@Component({
    components: {
        DeleteScheduleDialog,
        HeaderBar,
        Navigator,
        DialogButtons,
        ScheduleEditor,
    },
})
export default class ScheduleCreatePage extends Vue {

    private newSchedule!: CMS.Schedule;
    private selected: string = "period";

    async created() {
        MenusStore.init();
        SchedulesStore.init(this.menuId);
        this.selected = String(this.$route.query.selected);

        this.newSchedule = {
            id: Util.getTempId(SchedulesStore.all),
            menu_id: this.menuId,
            designated_date: '',
            start_date: CmsApiUtil.dateToDB(new Date()),
            end_date: '',
            start_time: '',
            end_time: '',
            weeks: [0, 1, 2, 3, 4, 5, 6]
        }
        this.isTabSelect(this.selected);
    }

    get menuId(): number {
        return Number(this.$route.params.menuId);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {};
    }

    get scheduleList(): CMS.Schedule[] {
        if (this.selected === 'period') {
            return SchedulesStore.period;
        } else {
            return SchedulesStore.day;
        }
    }

    private onScheduleChange(schedule: CMS.Schedule) {
        this.newSchedule = schedule;
        this.$forceUpdate();  //fixme forceUpdateなくしたい
    }

    private onClickCancel() {
        this.$router.push({name: 'menu_top'})
    }

    private onClickCreate() {
        SchedulesStore.create(this.newSchedule);
        this.newSchedule.id = Util.getTempId(SchedulesStore.all) - 1;  // 作成直後にいっしゅん同一時刻エラーメッセージ表示しちゃうのを回避
        this.$router.push({name: 'menu_top'})
    }

    private hasError(schedule: CMS.Schedule): boolean {
        if (this.selected == "period" && !CmsApiUtil.isValidDatePeriod(schedule.start_date, schedule.end_date)) {
            return true;
        }
        if (this.selected == "period" && !CmsApiUtil.isDuplicatePeriod(schedule, this.scheduleList)) {
            return true;
        }
        if (this.selected == "day" && !CmsApiUtil.isDuplicateDay(schedule, this.scheduleList)) {
            return true;
        }

        return false;
    }

    private isTabSelect(tab: string) {
        this.selected = tab;
        let edited: CMS.Schedule = Util.deepCopy(this.newSchedule);
        edited.start_time = '';
        edited.end_time   = '';
        if (tab == "period") {
            edited.designated_date = '';
            edited.start_date      = CmsApiUtil.dateToDB(new Date());
            edited.end_date        = '';
            edited.weeks      = [0, 1, 2, 3, 4, 5, 6];
        } else {
            edited.designated_date = '01';
            edited.start_date      = '';
            edited.end_date        = '';
            edited.weeks           = [];
        }
        this.newSchedule = edited;
    }
}
